document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-hbsr]').forEach(function (root) {
    // Hero gallery dots sync
    var gallery = root.querySelector('.hbsr__gallery');
    var dots = root.querySelectorAll('.hbsr__dots span');
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', function () {
        var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach(function (d, i) { d.style.background = i === idx ? '#1a1a1a' : '#d8d8d8'; });
      }, { passive: true });
    }

    // Reviews strip: light auto-scroll pause on touch/drag (kept subtle, no forced autoplay loop over user interaction)
    var reviews = root.querySelector('.hbsr__reviews');
    if (reviews) {
      var isDown = false;
      reviews.addEventListener('pointerdown', function () { isDown = true; });
      window.addEventListener('pointerup', function () { isDown = false; });
    }

    // Comments "add comment" focuses a no-op input (native app normally opens a form)
    var input = root.querySelector('.hbsr__comment-input');
    if (input) {
      input.addEventListener('click', function () {
        input.style.borderColor = '#e0537a';
      });
    }
  });
});
